import { makeStyles } from 'tss-react/mui';
import { keyframes } from '@mui/material/styles';
import { spacing } from '../../styles/jss/variables';
const labelSlideUp = keyframes `
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const useStyles = makeStyles()((theme) => ({
    container: { height: '100%' },
    imageContainer: {
        position: 'relative',
        width: '100%',
        // Make the container a square as all padding is calculated from width, not height
        '&span:after': {
            content: '""',
            display: 'block',
            paddingBottom: '100%',
        },
    },
    image: {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        display: 'block',
    },
    label: {
        paddingTop: spacing.xs,
        paddingBottom: spacing.xs,
        textAlign: 'center',
        '& span': Object.assign(Object.assign({}, theme.typography.small_bold), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.medium_regular) }),
    },
    badge: {
        position: 'absolute',
        left: theme.isFlyingFlowers ? undefined : spacing.small,
        top: theme.isFlyingFlowers ? undefined : spacing.small,
        right: theme.isFlyingFlowers ? spacing.xs : undefined,
        bottom: theme.isFlyingFlowers ? spacing.xs : undefined,
    },
    pimBadge: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        '& > *': {
            pointerEvents: 'auto',
        },
    },
    imageBlogArticleCard: {
        width: '60%',
        display: 'flex',
        margin: 'auto',
        objectFit: 'scale-down',
    },
    // Portrait fill mode — container fills parent height, image covers with cropping
    portraitFillContainer: {
        height: '100%',
        position: 'relative',
    },
    portraitCoverImage: {
        objectFit: 'cover',
        objectPosition: 'center top',
    },
    newImageContainer: {
        position: 'relative',
    },
    newImageLabelContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        textAlign: 'left',
        padding: `${spacing.xxs} ${spacing.xs}`,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        animation: `${labelSlideUp} 0.4s ease-out both`,
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
        },
        '& span': Object.assign(Object.assign({ color: '#000000', display: 'block' }, theme.typography.xxs_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.medium_regular) }),
    },
}));
export default useStyles;
